import intl from 'react-intl-universal';

import { findItemByKey, flatPriceList } from '@/redux/actions/reservation/helper';
import { ExchangeRentRoomInfo, ExchangeRoomRole } from '@/redux/reducers/reservation/base.d';

// 房型升降提示
export const ExchangeActionHint = {
  '0': intl.get('drawer_exchange_type_same_room'),
  '1': intl.get('drawer_exchange_type_same_price'),
  '2': intl.get('drawer_exchange_type_degrade_room'),
  '3': intl.get('drawer_exchange_type_upgrade_room'),
};

// 房型升降
export type ExchangeActionValue = keyof typeof ExchangeActionHint;

// 房型更换类型
export const getExchangeActionType: (
  roomList: ExchangeRentRoomInfo[],
  marketPriceMap: ReturnType<typeof flatPriceList>,
) => ExchangeActionValue = (roomList, marketPriceMap) => {
  const originRoom = findItemByKey(roomList, 'itemRole', ExchangeRoomRole.OriginRoom); // 原房间
  const targetRoom = findItemByKey(roomList, 'itemRole', ExchangeRoomRole.TargetRoom); // 新房间
  const originType = originRoom.roomTypeId;
  const exchangeType = targetRoom.roomTypeId;
  if (originType === exchangeType) return '0';
  const { cachePriceMap } = marketPriceMap;
  const firstDay = originRoom.roomPriceList[0].rentDate; // 入住第一天
  const originPrice = cachePriceMap[originType]?.[firstDay];
  const exchangePrice = cachePriceMap[exchangeType]?.[firstDay];
  let changeType: ExchangeActionValue = '0'; // 默认同房型
  switch (true) {
    case originPrice === exchangePrice:
      changeType = '1'; // 等价房型更换
      break;
    case originPrice > exchangePrice:
      changeType = '2'; // 升级房型
      break;
    case originPrice < exchangePrice:
      changeType = '3'; // 降级房型
      break;
    default:
      changeType = '0';
  }
  return changeType;
};

// 冲调备注校验
export const ReverseResonCodeQT = 'QT'; // 其他 时必填 否则选填

export const validReverseRemark = (_, value, resonCode) => {
  // 如果选填 只要填写了就要求至少三个字符 其至少包含一个汉字
  if (resonCode !== ReverseResonCodeQT) {
    if (value && value.length > 0) {
      if (value.length < 3 || !/[一-龥]/.test(value)) {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject(intl.get('bill_credit_please_input_carefully'));
      }
    }
  } else {
    if (!value || value.length < 3 || !/[一-龥]/.test(value)) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(intl.get('bill_credit_please_input_carefully'));
    }
  }
  return Promise.resolve();
};

//  选填如果填写了详情就要求 至少三个字符 其至少包含一个汉字
export const validDetailNotRequire = (value) => {
  if (value && value?.length > 0) {
    if (value.length < 3 || !/[一-龥]/.test(value)) {
      return true;
    }
  }
  return false;
};

// 必填 详情 至少三个字符 其至少包含一个汉字
export const validDetailRequire = (value) => {
  return !value || value.length < 3 || !/[一-龥]/.test(value);
};
